<template>
  <v-stepper
    v-model="passoAtual"
    class="mt-2 mt-md-5"
    style="box-shadow: none;"
  >
    <v-stepper-header
      class="grey lighten-3"
      style="box-shadow: none;"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-step
          :key="'step_' + index"
          :step="item.step"
          :complete="passoAtual > item.step"
          complete-icon="check"
          :data-cy="'passo_marcador_' + item.step"
        />

        <v-divider
          v-if="quantDePassos.length > item.step"
          :key="'divider_' + index"
        />
      </template>
    </v-stepper-header>

    <v-stepper-items
      class="grey lighten-3"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-content
          :key="'content_' + index"
          :step="item.step"
          :class="$vuetify.breakpoint.smAndDown ? 'height-content' : 'padding-b'"
          class="pa-0"
        >
          <PassoDadosCompra v-if="item.step === 1" />
          <PassoDadosPessoais
            v-if="item.step === 2"
            class="mb-md-12"
            @formValidado="ativarPasso($event, index)"
            @manterDadosBancarios="manterDados"
          />
          <PassoDadosBancarios
            v-if="item.step === 3"
            class="mb-md-5"
            @formValidado="ativarPasso($event, index)"
          />
          <PassoSobreReembolso
            v-if="item.step === 4"
            class="pb-md-5"
            :boleto-parcelado="dadosCompra.is_boleto_in_installments"
            @formValidado="ativarPasso($event,index)"
          />
          <PassoFaltaPouco
            v-if="item.step === 5"
            class="mb-md-4"
            @formValidado="ativarPasso($event,index)"
          />

          <div
            :class="$vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile botoes-rodape--stepper'"
            class="botoes-rodape --reembolso pa-3 pa-md-0 px-md-0"
          >
            <BtnVoltar
              :key="'voltar_' + index"
              :index="item.step"
              @irParaAnterior="novoValor => passoAtual = novoValor"
            />

            <BtnProsseguir
              v-if="item.step < 5"
              :key="'prosseguir_' + index"
              :index="item.step"
              :desabilitar-btn="item.possuiValidacao"
              :nao-proseguir="item.msgConfirmacao"
              @irParaProximo="novoValor => passoAtual = novoValor"
              @naoIrParaProximo="confirmacao => dialogConfirmacao = confirmacao"
            />

            <BtnEnviar
              v-else
              :dados-reembolso="dadosReembolso"
              :anexos="anexos"
              :desabilitar-btn="item.possuiValidacao"
              @respostaApi="showModal"
            />

            <ModalSolicitarReembolso
              v-if="item.step === 5"
              :dialog="dialog"
              :resposta-success="respostaApi"
              :produtor="nomeProdutor"
            />

            <ModalConfirmacaoDados
              v-if="item.step === 3"
              :index="item.step"
              :dialog="dialogConfirmacao"
              :dados-pessoais="quantDePassos[1]"
              :dados-bancarios="quantDePassos[2]"
              @changeDialog="dialog => dialogConfirmacao = dialog"
              @infoVerificadas="novoValor => passoAtual = novoValor"
            />
          </div>
        </v-stepper-content>
      </template>
    </v-stepper-items>
  </v-stepper>
</template>

<script>

import { mapGetters } from 'vuex';
import PassoDadosCompra from '@/components/SolicitacaoReembolso/PassoDadosCompra.vue';
import PassoDadosPessoais from '@/components/SolicitacaoReembolso/Boleto/PassoDadosPessoais.vue';
import PassoDadosBancarios from '@/components/SolicitacaoReembolso/Boleto/PassoDadosBancarios.vue';
import PassoSobreReembolso from '@/components/SolicitacaoReembolso/PassoSobreReembolso.vue';
import PassoFaltaPouco from '@/components/SolicitacaoReembolso/Boleto/PassoFaltaPouco.vue';
import BtnProsseguir from '@/components/Steppers/BtnProsseguir.vue';
import BtnEnviar from '@/components/SolicitacaoReembolso/BtnEnviar.vue';
import BtnVoltar from '@/components/Steppers/BtnVoltar.vue';
import ModalSolicitarReembolso from '@/components/SolicitacaoReembolso/ModalSolicitarReembolso.vue';
import ModalConfirmacaoDados from '@/components/SolicitacaoReembolso/Boleto/ModalConfirmacaoDados.vue';

export default {
  name: 'BoletoStepper',

  components: {
    PassoDadosCompra,
    PassoDadosPessoais,
    PassoDadosBancarios,
    PassoSobreReembolso,
    PassoFaltaPouco,
    BtnProsseguir,
    BtnEnviar,
    BtnVoltar,
    ModalSolicitarReembolso,
    ModalConfirmacaoDados,
  },

  props: {
    iniciarPasso: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      passoAtual: 1,
      btAtualDisabled: true,
      dadosReembolso: {
        venda: null,
        is_boleto: null,
        nomeFavorecido: null,
        fieldCpfCnpj: null,
        bankCode: null,
        tipoConta: null,
        agencyNumber: null,
        agencyCheckNumber: null,
        accountNumber: null,
        accountCheckNumber: null,
        operacaoVariacao: null,
        accepted_terms: null,
        category_reembolso: null,
        observacoes: null,
        is_credit_card: null,
        is_online_debt: null,
      },
      dialog: false,
      dialogConfirmacao: false,
      respostaApi: false,
      nomeProdutor: '',
      anexos: [],
      dadosVenda: {
        venda: '',
        is_credit_card: '',
        is_debit_card: '',
        is_boleto: '',
        category_reembolso: '',
        is_online_debt: '',
      },
      quantDePassos: [
        {
          step: 1, form: {}, possuiValidacao: false, msgConfirmacao: false,
        },
        {
          step: 2, form: {}, possuiValidacao: true, msgConfirmacao: false,
        },
        {
          step: 3, form: {}, possuiValidacao: true, msgConfirmacao: true,
        },
        {
          step: 4, form: {}, possuiValidacao: true, msgConfirmacao: false,
        },
        {
          step: 5, form: { accepted_terms: false }, possuiValidacao: true, msgConfirmacao: false,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),

    concordoTermos() {
      return this.quantDePassos[4].form.accepted_terms;
    },
  },

  watch: {
    passoAtual() {
      this.montarObjeto();
    },

    concordoTermos() {
      this.montarObjeto();
    },
  },

  mounted() {
    this.setDadosVenda();
    this.setPassoAtual();
    this.nomeProdutor = this.dadosCompra.vendedor || '';
  },

  methods: {
    setDadosVenda() {
      this.dadosVenda.venda = `${this.dadosCompra.venda}`;
      this.dadosVenda.is_credit_card = this.dadosCompra.cartaoCredito;
      this.dadosVenda.is_debit_card = this.dadosCompra.cartaoDebito;
      this.dadosVenda.is_boleto = this.dadosCompra.boleto;
      this.dadosVenda.is_online_debt = this.dadosCompra.is_online_debt;
      this.dadosVenda.category_reembolso = this.dadosCompra.category;
      this.quantDePassos[0].form = this.dadosVenda;
    },

    setPassoAtual() {
      if (this.iniciarPasso === 2) {
        this.passoAtual = this.iniciarPasso;
      }
    },

    ativarPasso(dadosForm, indexArray) {
      this.quantDePassos[indexArray].possuiValidacao = !dadosForm.validado;
      this.quantDePassos[indexArray].form = dadosForm.form;
    },

    montarObjeto() {
      if (this.passoAtual === 5 && this.concordoTermos) {
        const passoUm = this.quantDePassos[0].form;
        const passoDois = this.quantDePassos[1].form;
        const passoTres = this.quantDePassos[2].form;
        const passoQuatro = this.quantDePassos[3].form;
        const passoCinco = this.quantDePassos[4].form;
        Object.assign(this.dadosReembolso, passoUm, passoDois, passoTres, passoQuatro, passoCinco);
        this.anexos = passoQuatro.anexos;
      }
    },

    showModal(resposta) {
      this.dialog = true;
      this.respostaApi = resposta;
    },

    manterDados(v) {
      this.$emit('manterDadosBancarios', v);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
